import CategoryBreadcrumbs from '@anm/components/templates/CategoryBreadcrumbs';
import { EMBED_INTERNAL_PARAM } from '@anm/constants/wave-editor';
import { VideoTemplatesPageContext } from '@anm/contexts/VideoTemplatesPageContext';
import pagesData from '@anm/data/video-templates/pages';
import usePageParams from '@anm/hooks/usePageParams';
import { useContext, FC } from 'react';
import { useSelector } from 'react-redux';

import { templateSelectors } from '../../../store/modules/template';
import CategoryList from '../CategoryList';
import Search from '../Search';
import VideoAspectsDropdown from '../VideoAspectsDropdown';

import Wrapper, { MainTitle, SearchAndFormatsContainer } from './Wrapper';

const MAIN_PAGE_ICON_WIDTH = 400;
const DEFAULT_PAGE_ICON_WIDTH = 455;

const MAIN_PAGE_ICON_HEIGHT = 182;
const DEFAULT_PAGE_ICON_HEIGHT = 207;

const Header: FC = () => {
  const { embed } = usePageParams();
  const isEmbedView = embed === EMBED_INTERNAL_PARAM;

  const { pageName } = useContext(VideoTemplatesPageContext);
  const { color, title, description, icon } = pagesData[pageName].header;

  const currentTemplate = useSelector(templateSelectors.selectCurrentTemplate);
  const templateDisplayName = currentTemplate?.displayName;
  const templateDescription = currentTemplate?.description;

  const isPageWithoutBreadcrumbs = pageName === 'main' || pageName === 'search';
  const isPageWithoutFormatChooser = pageName.includes('live-streaming');

  const backgroundIconWidth = isPageWithoutBreadcrumbs ? MAIN_PAGE_ICON_WIDTH : DEFAULT_PAGE_ICON_WIDTH;
  const backgroundIconHeight = isPageWithoutBreadcrumbs ? MAIN_PAGE_ICON_HEIGHT : DEFAULT_PAGE_ICON_HEIGHT;

  return (
    <>
      <Wrapper
        {...{
          icon,
          color,
          isEmbedView,
          backgroundIconWidth,
          backgroundIconHeight
        }}
      >
        <SearchAndFormatsContainer>
          <Search />
          {!isPageWithoutFormatChooser && <VideoAspectsDropdown />}
        </SearchAndFormatsContainer>
        <CategoryBreadcrumbs />
        <MainTitle title={templateDisplayName || title} description={templateDescription || description} />
      </Wrapper>
      <CategoryList {...{ color }} />
    </>
  );
};

export default Header;
